<ng-template cellTemplate let-dataItem="dataItem" let-columnIndex="columnIndex">
    <div class="cell-wrapper"
         [ngClass]="cellClassGetter ? cellClassGetter(undefined, dataItem) : {}">
        <div class="constraint">
            <fui-checkbox-control [value]="dataItem | property : field" [readOnlyNotDisabled]="true"
                                  (click)="setupCellActivation(columnIndex, $event)"></fui-checkbox-control>
        </div>
    </div>
</ng-template>
<ng-template editTemplate
             let-dataItem="dataItem"
             let-rowIndex="rowIndex"
             let-columnIndex="columnIndex"
             let-column="column"
             let-formGroup="formGroup"
             let-isNew="isNew">
    <wbo-edit-grid-cell-activator [columnIndex]="columnIndex"
                                  [editControl]="editCheckbox"></wbo-edit-grid-cell-activator>
    <div class="edit-wrapper" [ngClass]="{'readonly': cellDisabled(formGroup, dataItem)}">
        <fui-checkbox-control #editCheckbox [formControl]="formGroup.get(column.field)" [attr.id]="elementId"
                              [ngClass]="cellClassGetter ? cellClassGetter(formGroup, dataItem) : {}"
                              [control]="formGroup.get(column.field)"
                              [readOnly]="cellDisabled(formGroup, dataItem)"
                              (valueChange)="controlValueChange($event, dataItem, formGroup)"
                              (focussed$)="columnFocusHandler(columnIndex)">
        </fui-checkbox-control>
    </div>
</ng-template>
